import { FacebookConfirmAction } from './facebook-confirm';
import { HTTP_STATUS_NO_CONTENT, HTTP_STATUS_BAD_REQUEST } from '../../../helpers/validation/common';

const successMock: FacebookConfirmAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_NO_CONTENT,
		playerId: 123456,
	});
};

const failMock: FacebookConfirmAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_BAD_REQUEST,
		errors: [{ code: 'be.api.auth.facebook.confirm-failed', message: 'Facebook confirm failed' }],
	});
};

export const facebookConfirmMocks: {
	success: FacebookConfirmAction;
	fail: FacebookConfirmAction;
} = {
	success: successMock,
	fail: failMock,
};
